try {
  Sentry.init({
    dsn: 'https://ae88c563a11f4b84a6b2699639fb6f8e@sentry.io/1187044',
  });
} catch (err) {
  console.log('Sentry init failed', err);
}

(function () {
  if (window.document.documentMode) {
    document.getElementsByClassName('ie11only').forEach(elt => elt.style.display = 'block')
  }

  const ERROR_KEY = 'shrimp-error';

  const strings = {
    en: {
      title: "Shrimp/&#x1f525;",
      terminology: "Terminology",
      logoTitle: "For help, contact ontoserver-support@csiro.au",
      eclBuilderTitle: "ECL Builder",
      login: "Login...",
      loginTitle: "Login to terminology server",
      go: "Go",
      adminUITitle: "Admin UI",
      browserWarning: "Internet Explorer is no longer officially supported. Please use a modern browser such as Edge, Firefox, Safari, or Chrome.",
      codesystems: "CodeSystems",
      valuesets: "ValueSets",
      ecl: "ECL",
      filterCodesystems: "filter code systems",
      serverEndpointPlaceholder: "Terminology Server endpoint URL",
      filterValuesets: "filter value sets",
      filterValuesetsTitle: "ValueSet filter",
      searchTerms: "search terms",
      requestLink: "Can't find the concept?",
      requestTitle: "Request new content be added to SNOMED CT-AU",
      property: "Property",
      value: "Value",
      loincContent: "LOINC® content is copyright © 1995 Regenstrief Institute, Inc. and the LOINC Committee, and available at no cost under the license at ",
      snomedContent: "This material includes SNOMED Clinical Terms® (SNOMED CT®) which is used by permission of the International Health Terminology Standards Development Organisation (IHTSDO). All rights reserved. SNOMED CT®, was originally created by The College of American Pathologists. “SNOMED” and “SNOMED CT” are registered trademarks of the IHTSDO"
    },
    fr: {
      title: "Shrimp/&#x1f525;",
      terminology: "Terminologie",
      logoTitle: "Pour obtenir de l'aide, contactez ontoserver-support@csiro.au",
      eclBuilderTitle: "Constructeur ECL",
      login: "Se connecter...",
      loginTitle: "Se connecter au serveur de terminologie",
      go: "Aller",
      adminUITitle: "Interface administrateur",
      browserWarning: "Internet Explorer n'est plus officiellement pris en charge. Veuillez utiliser un navigateur moderne tel que Edge, Firefox, Safari ou Chrome.",
      codesystems: "CodeSystems",
      valuesets: "ValueSets",
      ecl: "ECL",
      filterCodesystems: "filtrer les systèmes de code",
      serverEndpointPlaceholder: "URL de l'API du serveur de terminologie",
      filterValuesets: "filtrer les ensembles de valeurs",
      filterValuesetsTitle: "Filtre d'ensemble de valeurs",
      searchTerms: "termes de recherche",
      requestLink: "Vous ne trouvez pas le concept ?",
      requestTitle: "Demander l'ajout de nouveau contenu à SNOMED CT-AU",
      property: "Propriété",
      value: "Valeur",
      loincContent: "Le contenu de LOINC® est protégé par copyright © 1995 Regenstrief Institute, Inc. et le Comité LOINC, et disponible gratuitement sous la licence à ",
      snomedContent: "Ce matériel comprend des termes cliniques SNOMED® (SNOMED CT®) utilisés avec l'autorisation de l'Organisation internationale de développement des normes de terminologie de la santé (IHTSDO). Tous droits réservés. SNOMED CT®, a été créé à l'origine par le College of American Pathologists. “SNOMED” et “SNOMED CT” sont des marques déposées de l'IHTSDO"
    },
    id: {
      title: "Shrimp/&#x1f525;",
      terminology: "Terminologi",
      logoTitle: "Untuk bantuan, hubungi ontoserver-support@csiro.au",
      eclBuilderTitle: "Pembuat ECL",
      login: "Masuk...",
      loginTitle: "Masuk ke server terminologi",
      go: "Pergi",
      adminUITitle: "UI Admin",
      browserWarning: "Internet Explorer tidak lagi didukung secara resmi. Silakan gunakan browser modern seperti Edge, Firefox, Safari, atau Chrome.",
      codesystems: "CodeSystems",
      valuesets: "ValueSets",
      ecl: "ECL",
      filterCodesystems: "saring sistem kode",
      serverEndpointPlaceholder: "URL API Server Terminologi",
      filterValuesets: "saring set nilai",
      filterValuesetsTitle: "Filter ValueSet",
      searchTerms: "istilah pencarian",
      requestLink: "Tidak menemukan konsepnya?",
      requestTitle: "Meminta konten baru ditambahkan ke SNOMED CT-AU",
      property: "Properti",
      value: "Nilai",
      loincContent: "Konten LOINC® adalah hak cipta © 1995 Regenstrief Institute, Inc. dan Komite LOINC, dan tersedia tanpa biaya di bawah lisensi di ",
      snomedContent: "Materi ini mencakup SNOMED Clinical Terms® (SNOMED CT®) yang digunakan dengan izin dari International Health Terminology Standards Development Organisation (IHTSDO). Semua hak dilindungi undang-undang. SNOMED CT®, awalnya dibuat oleh The College of American Pathologists. “SNOMED” dan “SNOMED CT” adalah merek dagang terdaftar dari IHTSDO"
    }
  };

  function updateTranslations(lang) {
    const strs = (strings[lang] || strings['en']);

    document.getElementById('terminology-link').innerText = strs.terminology;
    document.getElementById('logo-title').title = strs.logoTitle;
    document.getElementById('ecl-link').title = strs.eclBuilderTitle;
    document.getElementById('fhir-server-login').innerText = strs.login;
    document.getElementById('fhir-server-login').title = strs.loginTitle;
    document.getElementById('fhir-server-link').title = strs.adminUITitle;
    document.getElementById('fhir-server-input').placeholder = strs.serverEndpointPlaceholder;
    document.getElementById('submit-btn').value = strs.go;
    document.getElementById('browser-warning').innerText = strs.browserWarning;
    document.getElementById('codesystems-label').innerText = strs.codesystems;
    document.getElementById('valuesets-label').innerText = strs.valuesets;
    document.getElementById('ecl-label').innerText = strs.ecl;
    document.getElementById('cslimit').placeholder = strs.filterCodesystems;

    document.getElementById('vslimit').title = strs.filterValuesetsTitle;
    document.getElementById('vslimit').placeholder = strs.filterValuesets;
    document.getElementById('ontosearch').placeholder = strs.searchTerms;
    document.getElementById('request-link').innerText = strs.requestLink;
    document.getElementById('request-link').title = strs.requestTitle;
    document.getElementById('property-label').innerText = strs.property;
    document.getElementById('value-label').innerText = strs.value;
    document.getElementById('loinc-content').innerText = strs.loincContent;
    document.getElementById('snomed-content').innerText = strs.snomedContent;
  }

  function initTranslations() {
    const select = document.getElementById('language-select');
    select.addEventListener('change', function() {
      const lang = this.value;
      Endpoint.setLanguage(lang);
      updateTranslations(lang);
      ContextManager.refresh();
      FocusManager.refresh();
    });
    select.value = Endpoint.getLanguage().substr(0, 2);
    updateTranslations(select.value);
  }

  function relaunch(error) {
    window.localStorage.setItem(ERROR_KEY, error)

    const urlParams = new URLSearchParams(window.location.search);
    const iss = urlParams.get('iss') || urlParams.get('fhir') || 'https://tx.ontoserver.csiro.au/fhir';
    urlParams.set('iss', iss);
    window.location = `launch.html?${urlParams.toString()}`
  }

  FHIR.oauth2.ready()
    .then(function (client) {
      const urlParams = new URLSearchParams(window.location.search);
console.log('OAUTH READY', window.location.search);
//Object.keys(urlParams).forEach(function (k) {
//  console.log('URL PARAM', k, urlParams[k]);
//});
//console.log('-------------------------------');

      const iss = urlParams.get('iss') || urlParams.get('fhir');
      // Also avoid GraphNet issue relating to iss param being used by RFC9207
      if (!urlParams.get('state') && !urlParams.get('code') && iss && iss !== client.state.serverUrl) {
        console.log('RELAUNCH', iss, client.state.serverUrl);
        relaunch();
      }
      urlParams.set('fhir', client.state.serverUrl)
      window.history.replaceState(null, '', '?' + urlParams.toString());

      Licence.init(debug);

      var stickySize = false;

      // Add / Update a key-value pair in the URL query parameters
      function updateUrlParameter(url, key, value) {
        // remove the hash part before operating on the url
        var i = url.indexOf('#'),
          hash = i === -1 ? '' : url.substr(i),
          re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");

        url = i === -1 ? url : url.substr(0, i);

        if (url.match(re)) {
          url = url.replace(re, '$1' + key + "=" + value + '$2');
        } else {
          var separator = url.indexOf('?') !== -1 ? "&" : "?";
          url = url + separator + key + "=" + value;
        }
        return url + hash;  // finally append the hash as well
      }

      /*
       * Supported parameters to Shrimp are:
       *   help		[true/false]
       *   iss		The FHIR endpoint URL
       *   fhir		The FHIR endpoint URL
       *   concept		One or more focus codes
       *   valueSet		Canonical of the focus ValueSet
       *   query		??
       *   search		??
       *   
       *   system		A CodeSystem URI
       *   version	A CodeSystem Version
       *   
       *   svg		The base URL of the axiom server (deprecated)
       */

      var COPYRIGHT = "(c) Copyright The Australian e-Health Research Centre, CSIRO, 2014-2020",
        debug = true,
        initialising = true,
        // sdiagram = d3.select("#sdiagram"),
        // slink = sdiagram.append("a"),
        name = d3.select("#name"),
        modalTimer,
        progressMax = 20,
        progress = document.getElementById('progress'),
        modal = document.getElementById('modal'),
        hvWidth, rsHeight,
        // svgBase = "https://ontoserver.csiro.au/axioms",
        sha256, svgId, svgRequest,
        endpointUrl,
        valueSetId, valueSetUri, valueSetLabel,
        expandLimit = 10000;

      function updateExpandLimit(url) {
        expandLimit = 10000;
        d3.json(url + '/metadata?_elements=software', function (error, result) {
          if (!error && (result.software.name||'').startsWith('Ontoserver')) {
            // Check the Ontoserver version
            const v = (result.software?.version || '0').split('.');
            if (v[0] > 6 || (v[0] == 6 && v[1] > 5)) {
              expandLimit = 200000;
            }
          }
        });
      }

      // slink
      //   .html("<br>&nbsp;&#x1F517;")
      //   .attr("target", "_blank")
      //   .classed("svglink", true)
      //   .style("text-decoration", "none")
      //   .style("vertical-align", "top");

      HistoryManager.init(debug, function (context) {
        updateExpandLimit(context.fhir);
        Endpoint.initEndpoint(context.fhir, { client: client, lang: context.lang });
        initTranslations(context.lang);
        ContextControl.initView(context.view);
        var v = context.valueset || 'http://snomed.info/sct?fhir_vs',
            t = context.valueset || 'All SNOMED CT Codes',
            s = context.system || 'http://snomed.info/sct';
        ContextManager.initFocus({ v: v, t: t, i: v, s: s, sv: context.version });
        SearchControl.initSearch(context.search);
        context.concept = context.concept || ['138875005'];
        if (context.concept) {
          FocusManager.initFocus(mapFocusContext(context));
        }
      });

      var authHandled = false;

      Endpoint.settings.messageElt = d3.select("#messages");
      Endpoint.init(debug && false);
      Endpoint.addAuthListener(function (error) {
        if (!authHandled) {
          authHandled = true;
          if (confirm("Access to the terminology server requires authorisation.  Login?")) {
            Endpoint.login();
          }
        }
      });
      Endpoint.addCallListener(function (count) {
        if (!count) {
          modalTimer = setTimeout(function () { modal.style.display = 'none'; }, 1000);
        } else {
          clearTimeout(modalTimer);
        }

        if (progress && progress.ldBar) {
          var value = 100 * count / Math.max(progressMax, count + 1);
          progress.ldBar.set(value);
        }
      });
      Endpoint.addListener(function (url) {
        // TODO refactor parameter and history handling
        // History.update({fhir: url});
/*
        if ('https:' == window.location.protocol && url && url.match(/^http:/)) {
          console.log('Cannot talk to a non-secure (HTTP) endpoint from secure (HTTPS) Shrimp, trying non-secure (HTTP) Shrimp instead.');
          // TODO - check use of assign(...) vs normal assignment with =
          window.location.assign('http' + window.location.href.substring(5));
        }
*/

        const auth = d3.select("#fhir-server-login");
        if (Endpoint.isLoggedIn()) {
          auth.text('Logout...');
          auth.node().onclick = Endpoint.logout;
        } else {
          auth.text('Login...');
          auth.node().onclick = Endpoint.login;
        }

        updateExpandLimit(url);

        d3.select("#fhir-server-input").node().value = url;
        if (url.startsWith('https://api.healthterminologies.gov.au/integration/')) {
          d3.select("#fhir-server-link").attr('href', 'ONTOCMD/launch?iss=' + encodeURI(url));
        } else {
          d3.select("#fhir-server-link").attr('href', url);
        }
        d3.select("#eplogo").attr('src', url + '/.well-known/organisation_logo.png').style('display', 'inline');

        d3.selectAll(".fhirUrl")
          .each(function () {
            this.href = updateUrlParameter(this.href, 'fhir', url);
          });

        HistoryManager.track({ fhir: url });
        VersionManager.setEndpoint(url);
        ContextManager.refresh();
        FocusManager.refresh();
      });


      VersionManager.init(debug);

      ContextControl.init(debug);
      VersionManager.addListener(function (url) {
        ContextControl.setEndpoint(url);
      });

      FocusManager.init(debug);
      ContextManager.init(debug);

      // PropertyView.settings.fields = ['*'];	// doesn't work wit subproperties yet
      PropertyView.settings.fieldMap = {
        artgIds: "ARTGID",
        display: 'Preferred',
        designation: 'Designation',
        'http://id.who.int/icd11/mms/designation|term': 'Index Term',
        inactive: 'Inactive',	// For old Ontoserver 4.x
        property: {
          // SCT props
          inactive: 'Inactive',
          moduleId: 'Module ID',
          effectiveTime: 'Effective Time',
          sufficientlyDefined: "Fully Defined",
          // ICD-11 props
          'abstract': 'Abstract',
          kind: 'Kind',
          postcoordinationScale: 'Post-Coordination Scale',
          terms: 'Terms',
          exclusion: 'Exclusion',
          codingNode: 'Coding Note',
        },
      };
      PropertyView.init(debug);

      DiagrammingView.settings.Endpoint = Endpoint;
      DiagrammingView.settings.onclick = (coding, event) => {
        if (event.ctrlKey || event.metaKey) {
          FocusManager.toggleFocus([coding]);
        } else {
          FocusManager.setFocus([coding]);
        }
        HistoryManager.pushState();
      }
      DiagrammingView.init(debug);

      // focus listener for HierarchyView
      var reqs = [];
      FocusManager.addListener(function (concepts) {
        if (concepts && concepts.length > 0) {
          showConcepts(concepts, reqs);
          // ga('send', 'event', 'focus', 'show');
          HistoryManager.track({ concept: concepts.map(function (c) { return c.c; }), system: concepts[0].s, version: concepts[0].v });
        }
      });

      FocusManager.addListener(function (concepts) {
        if (concepts && concepts.length == 0) {
          showConcepts(concepts, reqs);
          // ga('send', 'event', 'focus', 'reset');
          HistoryManager.track({ concept: [] });
        }
      });

      FocusManager.addListener(function (concepts) {
        if (concepts && concepts.length > 0) {
          SearchControl.selectConcepts(concepts);
        } else {
          SearchControl.selectConcepts([]);
        }
      });

      // focus listener for PropertyView
      FocusManager.addListener(function (concepts) {
        if (concepts && concepts.length > 0) {
          PropertyView.showConcept(concepts[0]);
        } else {
          PropertyView.clear();
        }
      });

      // focus listener for DiagrammingView
      FocusManager.addListener(function (concepts) {
        DiagrammingView.showConcepts(concepts);
      });

      // // Everything we need to re-write / re-init when Endpoint changes
      // Endpoint.addListener(function (url) {
      //   // TODO - this should track what's happening in the SearchControl !!
      //   // d3.select("#contentRequest").style('display', 'http://snomed.info/sct' === systemUri ? 'block' : 'none');

      //   if (endpointUrl === url) {
      //     return;
      //   }

      //   VersionManager.setEndpoint(url);
      // });

      //  VersionManager.addListener(function (systemId, versionId, valueset) {
      //    systemURI = systemId;
      //    versionURI = versionId;
      //
      //    name.text(VersionManager.getName());
      //
      //    if (queryParams.valueset) {
      //      Endpoint.setVersion(systemId, versionId, queryParams.valueset);
      //    } else {
      //      Endpoint.setVersion(systemId, versionId, valueset);
      //    }
      //  });

      SearchControl.addListener(function (codings) {
        FocusManager.setFocus(codings);
        // ga('send', 'event', 'search', 'select');
      });

      SearchControl.init(debug);

      ContextControl.addListener(function (filter) {
        ContextManager.setFocus(filter);
      });
      ContextControl.addViewListener(function (view) {
        SearchControl.setSearch('');
        HistoryManager.track({ view: view, search: null });
      });

      function arraysEqual(a, b) {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length != b.length) return false;

        try {
          a.sort();
          b.sort();

          for (var i = 0; i < a.length; ++i) {
            if (a[i] !== b[i]) return false;
          }
          return true;
        } catch (e) {
          console.error(a, b, e);
          return false;
        }
      }

      function runTour() {
        // FIXME tour is actually broken :-(

        // this does our lazy loading
        yepnope({
          test: function () { return typeof tour === "undefined"; },
          yep: ["../lib/jquery.min.js", "../lib/bootstrap-tour-standalone.min.js", "tour.js"],
          complete: function () {
            tour.init(debug);
            tour.start(true);
          },
        });
      }

      HierarchyView.settings.containerId = "#chart";
      HierarchyView.settings.help = runTour;
      HierarchyView.init(debug);
      HierarchyView.addListener(function (concepts) {
        const event = d3.event;
        if (event.shiftKey || event.ctrlKey || event.metaKey) {
          FocusManager.toggleFocus(concepts);
        } else {
          FocusManager.setFocus(concepts);
        }
      });

      d3.select("#dragbar2")
        .on("mousedown", function (evt) {
          var e = d3.event;
          if (e.button !== 0) return;

          d3.event.preventDefault(); // disable text dragging etc

          var outer = d3.select("#box2"),
            t = outer.node().getBoundingClientRect().top,
            m = document.documentElement.clientHeight - t - 20,
            h = outer.style('height'),
            hh = Math.min(Math.max(100, e.pageY - t), m),
            ghost = outer.append("div")
              .style("position", "absolute")
              .style("cursor", "ns-resize")
              .style("z-index", 999)
              .style("background-color", "grey")
              .style("opacity", "0.5")
              .style("height", "5px")
              .style("width", "100%")
              .style("left", "0px")
              .style("top", hh - 4 + "px"),
            w = d3.select(window)
              .on("mousemove", mousemove)
              .on("mouseup", mouseup);

          function mousemove() {
            var e = d3.event;

            hh = Math.min(Math.max(100, e.pageY - t), m);
            ghost.style("top", hh - 4 + "px");
          }

          function mouseup() {
            if (stickySize && window.sessionStorage) {
              window.sessionStorage.setItem("rsHeight", hh);
            }
            rsHeight = hh;
            ghost.remove();
            outer.select('.resultlist').style('height', hh + "px");
            w.on("mousemove", null).on("mouseup", null);
          }

        });

      d3.select("#dragbar")
        .on("mousedown", function (evt) {
          var e = d3.event;
          if (e.button !== 0) return;

          d3.event.preventDefault(); // disable text dragging etc

          var outer = d3.select("#box"),
            ww = Math.max(600, e.pageX),
            ghost = outer.append("div")
              .style("position", "absolute")
              .style("cursor", "ew-resize")
              .style("z-index", 999)
              .style("background-color", "grey")
              .style("opacity", "0.5")
              .style("width", "5px")
              .style("height", "100%")
              .style("top", "0px")
              .style("left", ww - 4 + "px"),
            w = d3.select(window)
              .on("mousemove", mousemove)
              .on("mouseup", mouseup);

          function mousemove() {
            var e = d3.event,
              limit = (window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth) - 290;

            ww = Math.min(limit, Math.max(600, e.pageX));
            ghost.style("left", ww - 5 + "px");
          }

          function mouseup() {
            ww = ww - 8;
            var hh = ww / 2.4;

            if (stickySize && window.sessionStorage) {
              window.sessionStorage.setItem("hvWidth", ww);
            }
            hvWidth = ww;
            Endpoint.settings.messageElt.style("max-width", ww + "px");
            HierarchyView.resize(ww, hh);
            HierarchyView.recenter();
            ghost.remove();
            w.on("mousemove", null).on("mouseup", null);
          }

        });

      if (typeof window.orientation === "undefined") {
        d3.select(window).on('resize', resize);
      } else {
        // It's a "tablet" - only resize comes from rotation, and resize events have wrong
        // values on ipad etc since they happen before the orientationchange
        d3.select(window).on('orientationchange', resize);
      }

      resize();

      /*
        d3.select('#endpoint').on("change", function (arg) {
          var e = d3.select('#endpoint').node(),
              endpoint = e.options[e.selectedIndex].value;
      
          // queryParams.fhir = setEndpoint(endpoint);
      
          window.location.search='?fhir='+endpoint;
      
          // FocusManager.refresh();
        });
      */

      function resize() {
        // see http://stackoverflow.com/questions/3437786/how-to-get-web-page-size-browser-window-size-screen-size-in-a-cross-browser-wa
        var
          d = document,
          e = d.documentElement,
          g = d.getElementsByTagName('body')[0],
          x = window.innerWidth || e.clientWidth || g.clientWidth,
          y = window.innerHeight || e.clientHeight || g.clientHeight,
          resultsWidth = Math.min(300, (0.32 * x) - 10);

        var
          width = (stickySize && window.sessionStorage && window.sessionStorage.getItem("hvWidth"))
            || hvWidth
            || (x - resultsWidth),	// Math.min(x*0.7, x-240);
          height = width / 2.4;

        if (stickySize && window.sessionStorage) {
          window.sessionStorage.setItem("hvWidth", width);
          d3.select("#box2")
            .select('.resultlist')
            .style('height', window.sessionStorage.getItem("rsHeight") + "px");
        }
        hvWidth = width;

        // update width and height
        Endpoint.settings.messageElt.style("max-width", width + "px");
        HierarchyView.resize(width, height);
        HierarchyView.recenter();
      }

      function showRootConcepts(cb) {
        const rootLimit = 3;

        var valueSet = ContextControl.getTlc();

        if (valueSet) {
          var options = {
            fields: ["total", "contains"],
          },
            params = {
              "resourceType": "Parameters",
              "parameter": [
                { "name": "valueSet", "resource": valueSet },
                { "name": "count", "valueInteger": rootLimit },
                { "name": "activeOnly", "valueBoolean": true },
              ]
            };
          options.valueSet = params;

          Endpoint.expandVs(options, function (error, result) {
            if (error) {
              Endpoint.settings.messageElt && Endpoint.settings.messageElt.text('Server failed to return ancestor concepts');
            } else {
              var members = (result.contains || []).map(function (e) { return { c: e.code, s: e.system, v: e.version }; });
              if (!members.length || result.total > rootLimit) {
                HierarchyView.showConcepts([]);
                FocusManager.setFocus([]);
              } else {
                FocusManager.setFocus(members);
              }
            }
            if (cb) cb();
          });
        } else {
          HierarchyView.showConcepts([], function (error) {
            if (!error) {
              HierarchyView.setFocus([]);
            }

            if (cb) cb();
          });
        }
      }

      function showConcepts(concepts, reqs) {
        if (!concepts) return;

        reqs.forEach(function (rq) {
          rq.abort();
        });
        reqs.length = 0;

        // Display our spinner after a delay, just to provide feedback that 'something' is happening
        var timer = setTimeout(function () { modal.style.display = 'block'; }, 600);

        function handleError(error, result) {
          clearTimeout(timer);
          modal.style.display = 'none';

          console.error(error);
          // alert("ERROR: " + error);
          return;
        }

        // nothing to display; clear the hierarchy view
        if (!concepts.length) {
          showRootConcepts(function () {
            clearTimeout(timer);
            modal.style.display = 'none';
          });
          return;
        }

        // Note the limit value; we'll never attempt to display more than expandLimit nodes.

        function refsetMembership(concepts) {
          var filter = SearchControl.getFilter();

          if (filter && filter.endsWith('?fhir_vs')) {
            filter = null;
          }
          concepts = concepts.filter(function (coding) { return 'http://snomed.info/sct' === coding.s; });

          if (filter && concepts.length > 0) {

            var options = {
              fields: ["total", "contains"],
            },
              valueSet = valueSetForCodings(concepts, function (concept) {
                return [{
                  "valueSet": filter,
                  "system": concept.s,
                  "version": concept.v,
                  "filter": [{ property: 'parent', op: '=', value: concept.c }],
                }, {
                  "valueSet": filter,
                  "system": concept.s,
                  "version": concept.v,
                  // "filter": {property: 'concept', op: 'generalizes', value: concept.c},
                  "filter": [{ property: 'expression', op: '=', value: ">> " + concept.c }],
                }];
              }),
              params = {
                "resourceType": "Parameters",
                "parameter": [{
                  "name": "valueSet",
                  "resource": valueSet,
                }]
              };
            options.valueSet = params;

            reqs.push(Endpoint.expandVs(options, function (error, result) {
              if (error) {
                return handleError(error, result);
              }

              var members = (result.contains || []).map(function (e) { return { c: e.code, s: e.system, v: e.version }; });
              HierarchyView.highlight(members);
            }));
          }

          clearTimeout(timer);
          modal.style.display = 'none';
        }

        function valueSetForCodings(codings, cb) {
          var groups = {},
            valueSet;

          codings.forEach(function (element) {
            var key = element.s + '|' + element.v;
            groups[key] = groups[key] || [];
            groups[key].push(element);
          });

          return {
            "resourceType": "ValueSet",
            "compose": {
              "include": Object.values(groups).flatMap(function (cs) {
                return cs.flatMap(cb);
              })
            }
          };
        }

        function displayRows(foci, rows, total, done) {
          if (rows && rows.length < total) {
            // too many
            console.log('too many concepts to display all', rows.length, total);
            if (Endpoint.settings.messageElt) {
              var messageElt = Endpoint.settings.messageElt;
              messageElt.text(new Date().toLocaleTimeString() + ' ' + 'Limiting display to ' + rows.length + ' of ' + total);
              setTimeout(function () {
                messageElt.text('');
              }, 30 * 1000);
            }
          }

          (rows || []).forEach(function (row) {
            row.version = row.version;	// TODO???
          });

          HierarchyView.showConcepts(rows, function (error) {
            if (!error) {
              HierarchyView.setFocus(foci);
            }

            if (done) {
              refsetMembership(concepts);
            }
          }, foci);
        }

        var queryAncestors = concepts.flatMap(function (c) {
          var versions = c.v && [c.v];
          if ('http://snomed.info/sct' === c.s) {
            return { query: ['expression', '=', ">> " + c.c], systems: [c.s], versions: versions };
          } else if ('http://loinc.org' === c.s) {
            return [{ query: ['concept', '=', c.c], systems: [c.s], versions: versions }, { query: ['child', '=', c.c], systems: [c.s], versions: versions }];
          } else {
            return { query: ['concept', 'generalizes', c.c], systems: [c.s], versions: versions };
          }
        }),

          queryChildren = concepts.map(function (c) {
            var versions = c.v && [c.v];
            return { query: ['parent', '=', c.c], systems: [c.s], versions: versions };
          }),

          options = {
            fields: ["total", "contains"],
            parents: true,
            limit: expandLimit,
          };

        options.disjunction = queryAncestors;
        reqs.push(Endpoint.findConceptsByQuery(options, function (error, result) {
          if (error) {
            console.error('ancestors', error);
            return handleError(error, result);
          }

          var rows = result.contains,
              total = result.total;

          displayRows(concepts, rows, total, false);

          options.disjunction = queryChildren;
          reqs.push(Endpoint.findConceptsByQuery(options, function (error, result) {
            if (error) {
              console.error('children', error);
              clearTimeout(timer);
              modal.style.display = 'none';
            } else if (result.contains && result.contains.length > 0) {
              rows = rows.concat(result.contains);
              total = total + result.total;

              displayRows(concepts, rows, total, true);
            } else {
              refsetMembership(concepts);
            }
          }));
        }));
      }

      ContextManager.addListener(function (focus) {
        if (focus && focus.length > 0) {
          const context = focus[0];

          ContextControl.setFocus(context);

          valueSetLabel = context.t;
          HierarchyView.setBanner(context.t);
          SearchControl.setFilter(context.v, context.version);
          d3.select("#contentRequest").style('visibility', context.v && context.v.startsWith('http://snomed.info/sct/32506021000036107') ? 'visible' : 'hidden');
          HistoryManager.track({ valueset: context.v, title: context.t });
          const id = context.v + '|' + context.version;
          const props = [
            // { id: id, k: 'id', v: context.id },
            { id: id, k: 'name', v: context.t },
            { id: id, k: 'ValueSet', v: context.v },
          ];
          ['version', 'date', 'description', 'publisher']
            .forEach(function (k) {
              if (context[k]) {
                props.push({ id: id, k: k, v: context[k] });
              }
            });
          PropertyView.showProps(props);
        } else {
          valueSetLabel = '';
          HierarchyView.setBanner();
          SearchControl.setFilter([]);
          d3.select("#contentRequest").style('visibility', 'hidden');
          HistoryManager.track({ valueset: [] });
        }
        name.text(valueSetLabel);
        if (!initialising) {
          showRootConcepts();
          FocusManager.setFocus([]);
        }
        SearchControl.update();
      });

      function mapFocusContext(context) {
        var focus;
        if (Array.isArray(context.concept)) {
          focus = context.concept.map(function (c) { return { s: context.system, v: context.version, c: c }; });
        } else {
          focus = [{ s: context.system, v: context.version, c: context.concept }];
        }
        return focus;
      }

      HistoryManager.addListener(function (context) {
        if (context.lang) {
          Endpoint.setLanguage(context.lang);
        }

        Endpoint.setEndpoint(context.fhir);

        if (context.view) {
          ContextControl.setView(context.view);
        }

        if (context.valueset) {
          var v = context.valueset;
          ContextManager.setFocus({ v: v, t: v, i: v, s: context.system });
        }

        if (context.search) {
          SearchControl.setSearch(context.search);
          SearchControl.update();
          HistoryManager.track({ search: null });
        }

        if (context.concept) {
          FocusManager.setFocus(mapFocusContext(context));
        }

        // if (context.tour) {
        //   HistoryManager.track({ tour: null });
        //   runTour();
        // }

      });

      Endpoint.setEndpoint();

      const vmInit = () => {
        setTimeout(function () {
          initialising = false;
          VersionManager.removeListener(vmInit);
        }, 1000);
      }

      VersionManager.addListener(vmInit)

      // if (HistoryManager.get('tour')) {
      //   HistoryManager.track({ tour: null });
      //   runTour();
      // }

      HistoryManager.refresh();

      urlParams.delete('session_state');

      window.localStorage.removeItem(ERROR_KEY)
    })
    .catch(function (error) {
      console.log('Error', error);
      try {
        Sentry.captureException(error);
      } catch (err) {
        console.log('Sentry error', err);
      }

      const priorError = window.localStorage.getItem(ERROR_KEY);
      if (priorError) {
        if (confirm(`${error}\n${priorError}\n\nClick OK to re-launch.\n`)) {
          relaunch(error);
        }
      } else {
        relaunch(error);
      }
    });
})();
